<template>
  <div class="p-3 bg-white">
    <div id="EditProjectFormContainer" class="vs-con-loading__container">
      <shared-project-edit
        @editProjectSuccess="editProjectSuccess"
        :progressStatusOptions="progressStatusOptions"
        :userOptions="userOptions"
      ></shared-project-edit>

      <div class="text-center">
        <vs-button id="editProjectButton" class="m-2" color="primary" type="filled" @click.prevent="editProject">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditProject">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Project from '@/models/Project'
import SharedProjectEdit from '@/views/Shared/Projects/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Project.Edit',
  components: {
    SharedProjectEdit
  },
  data () {
    return {
      progressStatusOptions: [],
      userOptions: []
    }
  },
  mounted () {
    this.loadProjects(this.$route.params.id)
  },
  methods: {
    async loadProjects (projectId) {
      const response = await Project.all()
      this.progressStatusOptions = response.data.meta.options.progressStatuses
      this.userOptions = response.data.meta.options.users

      EventBus.$emit('initEditProject', {id: projectId})

    },
    editProject () {
      EventBus.$emit('initUpdateProject')
    },
    editProjectSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_project_table')
      window.close()
    },
    cancelEditProject () {
      this.$windowOpenerHelper.notifyOpener('reload_project_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
